<div class="common-modal__container">
  <div class="common-modal__header">
    <span
      class="common-modal__text-header"
      [afTranslate]="'users-admin.import.dialog-title-' + type">
    </span>
  </div>
  <div class="common-modal__content">
      @if (importModal.view === 'select-file') {
        <div class="common-modal__form-container">
          <div class="common-container__mandatory-obligatory-message-form">
            <span class="common-tag__mandatory-text-asterisk">
              *
            </span>
            <span
              [afTranslate]="'common.required-fields'"
              class="common-tag__mandatory-label-text-obligatory-message">
              _Campos obligatorios
            </span>
          </div>
          <field-type-onefile
            [field]="importModal.fileField"
            [type]="'new'"
            [fileInfo]="importModal.fileInfo"
            (itemSelected)="fileSelected($event)">
          </field-type-onefile>
        </div>
      }
      @else if (importModal.view === 'analized-contacts' || importModal.view === 'analized-clients') {
        <div class="common-import-modal__analized-container">
          <div class="common-import-modal__analized-header">
            <span
              [afTranslate]="'users-admin.import.' + type + '-import-title'"
              class="common-modal__content-header-info flex-[1_0_0]">
              _Información sobre las fichas de (organización/contacto) analizadas:
            </span>
            <div #indexContainer>
              <button
                (click)="toggleIndexList($event)"
                class="common-button__text-noborder">
                <i class="lf-icon-angle-down common-icon__md">
                </i>
                <span
                  [afTranslate]="'users-admin.import.clients-index'"
                  class="common-button__text-title">
                  _Indice de fichas
                </span>
                <div class="common-badge__badge-block">
                  <span class="common-badge__square-md">
                    {{importModal.allFields.length}}
                  </span>
                </div>
              </button>
              <p-overlayPanel styleClass="common-dropdown-overlay__tabs-container">
                <ng-template pTemplate="content">
                  <div class="common-dropdown-list__user-list-container-dropdown">
                    <ul class="common-tab__tertiary-list-block common-tab__tertiary-list-block--borderer">
                      <li>
                        <button
                          (click)="filterToShow('all')"
                          [ngClass]="{
                            'common-tab__tertiary--selected': importModal.typeSelect == 'all'
                          }"
                          class="common-tab__tertiary">
                          <p
                            [afTranslate]="'common.total'"
                            class="common-tab__tertiary-button-text">
                            _Total
                          </p>
                        </button>
                      </li>
                      <li>
                        <button
                          (click)="filterToShow('validate')"
                          [ngClass]="{
                            'common-tab__tertiary--selected': importModal.typeSelect == 'validate'
                          }"
                          class="common-tab__tertiary">
                          <p
                            [afTranslate]="'users-admin.import.validate-contacts-card'"
                            class="common-tab__tertiary-button-text">
                            _Validadas
                          </p>
                        </button>
                      </li>
                      <li>
                        <button
                          (click)="filterToShow('error')"
                          [ngClass]="{
                            'common-tab__tertiary--selected': importModal.typeSelect == 'error'
                          }"
                          class="common-tab__tertiary">
                          <p
                            [afTranslate]="'common.error'"
                            class="common-tab__tertiary-button-text">
                            _Error
                          </p>
                        </button>
                      </li>
                    </ul>
                    <div class="common-dropdown-list__user-list-container-header-dropdown">
                      <div class="common-search__container-tonal common-search__container-tonal--with-button-lg">
                        <div class="common-search__container-input-text">
                          <input
                            type="search"
                            class="common-search__input-text"
                            [(ngModel)]="importModal.searchContact"
                            placeholder="{{'common.search-item' | afTranslate}}">
                        </div>
                        <div class="common-search__block-button-search">
                          @if (importModal.searchContact) {
                            <button class="common-button__icon-xs-noborder"
                              (click)="importModal.searchContact = ''">
                              <i class="lf-icon-close-thick common-icon__sm"></i>
                            </button>
                          }
                          <div class="h-[22px]"
                            [ngClass]="importModal.searchContact ? 'common-divider__vertical-main-1000' : 'common-divider__vertical-grey-400'">
                          </div>
                          <i [ngClass]="{
                              'common-search__icon-search-enabled': importModal.searchContact,
                              'common-search__icon-search-disabled': !importModal.searchContact,
                            }"
                            class="lf-icon-search common-icon__md">
                          </i>
                        </div>
                      </div>
                    </div>
                    <ul class="common-dropdown-list__user-dropdown-list">
                      @for (contact of importModal.allFields | byWord: importModal.searchContact:['nameComplete']; track $index) {
                        @if (importModal.typeSelect === 'all' || importModal.typeSelect === contact.type) {
                          <li class="common-dropdown-list__user-item h-[38px]">
                            <div class="common-button__block-button-md-checkbox">
                              <i
                                [ngClass]="!contact.errorList.length ? 'lf-icon-check-round' : 'lf-icon-close-round'"
                                class="common-icon__md common-special-icon__solid">
                              </i>
                            </div>
                            <span-tooltip
                              class="common-dropdown-list__user-item-text"
                              [text]="contact.nameComplete"
                              [tooltipPosition]="'top'">
                            </span-tooltip>
                          </li>
                        }
                      }
                    </ul>
                  </div>
                </ng-template>
              </p-overlayPanel>
            </div>
          </div>
          <ul class="common-import-modal__analized-body">
            <li class="common-diagram-card__counter-card-block !w-full h-full">
              <p
                [afTranslate]="'common.total'"
                class="common-diagram-card__counter-card-title-md">
                _Total
              </p>
              <div class="common-diagram-card__counter-card-count-block">
                <p class="common-diagram-card__counter-card-count-text">
                  {{importModal.allFields.length}}
                </p>
              </div>
              <div class="common-diagram-card__counter-card-bootm-block">
                <i class="lf-icon-build common-icon__xl common-import-modal__analized-total-icon">
                </i>
              </div>
            </li>
            <li class="common-diagram-card__counter-card-block !w-full h-full">
              <p
                [afTranslate]="'users-admin.import.validate-contacts-card'"
                class="common-diagram-card__counter-card-title-md">
                _Validadas
              </p>
              <div class="common-diagram-card__counter-card-count-block">
                <p class="common-diagram-card__counter-card-count-text">
                  {{importModal.validateFields.length}}
                </p>
              </div>
              <div class="common-diagram-card__counter-card-bootm-block">
                <i class="lf-icon-check-round common-icon__xl common-special-icon__solid">
                </i>
              </div>
            </li>
            <li class="common-diagram-card__counter-card-block !w-full h-full">
              <p
                [afTranslate]="'common.error'"
                class="common-diagram-card__counter-card-title-md">
                _Error
              </p>
              <div class="common-diagram-card__counter-card-count-block">
                <p class="common-diagram-card__counter-card-count-text">
                  {{errorFields.length}}
                </p>
              </div>
              <div class="common-diagram-card__counter-card-bootm-block">
                <i class="lf-icon-close-round common-icon__xl common-special-icon__solid"></i>
                @if (errorFields.length) {
                  <button
                    (click)="changeView('error-contacts')"
                    class="common-button__link">
                    <span
                      [afTranslate]="'users-admin.import.errors-form'"
                      class="common-button__link-text">
                      _Informe de errores
                    </span>
                  </button>
                }
              </div>
            </li>
          </ul>
        </div>
      }
      @else if (importModal.view === 'error-contacts' || importModal.view === 'error-concepts' || importModal.view === 'warning-fields' || importModal.view === 'error-clients') {
        @if (importModal.view == 'warning-fields' && showWarningInfo) {
          <div class="common-status-message__g-container-warning">
            <i class="lf-icon-warning-full common-status-message__icon-md">
            </i>
            <div class="common-status-message__g-content">
              <div class="common-status-message__g-icon-text-content">
                <div class="common-status-message__g-title-subtitle">
                  <span
                    afTranslate="users-admin.import.warning-info-text"
                    class="common-status-message__g-subtitle">
                    Subtitulo mensaje
                  </span>
                </div>
                <button
                  (click)="showWarningInfo = false"
                  class="common-button__icon-xs-noborder">
                  <i class="lf-icon-close-thick common-icon__sm">
                  </i>
                </button>
              </div>
            </div>
          </div>
        }
        <div class="common-import-modal__errors-container">
          <div class="common-import-modal__errors-header">
            <span
              [afTranslate]="'users-admin.import.' + importModal.view"
              class="common-import-modal__errors-title">
              _Fichas con errores de validación || _Instancias incompletas pero válidas para la importación
            </span>
            <div class="common-badge__badge-block">
              <span class="common-badge__square-md">
                {{(importModal.view == 'warning-fields') ? incompleteFields.length : errorFields.length}}
              </span>
            </div>
          </div>
          <ul class="common-import-modal__errors-list">
            @for (contact of importModal.filterErrorFields; track $index) {
              @for (error of contact.errorList; track $index) {
                <li class="common-import-modal__errors-list-item">
                  <i class="lf-icon-build common-icon__md common-import-modal__analized-total-icon">
                  </i>
                  <div class="common-import-modal__errors-list-item-text">
                    <span class="w-[80px]">
                      {{contact.nameComplete}}
                    </span>
                    <span>
                      {{error.errorType}}: {{error.errorDescription}}
                    </span>
                  </div>
                </li>
              }
            }
          </ul>
        </div>
      }
      @else if (importModal.view === 'analized-concepts') {
        <div class="common-import-modal__analized-container">
          <div class="common-import-modal__analized-header">
            <span
              [afTranslate]="'users-admin.import.concepts-import-title'"
              class="common-modal__content-header-info flex-[1_0_0]">
              _Información sobre las instancias analizadas:
            </span>
          </div>
          <ul class="common-modal__form-container-extend-row">
            <li class="common-diagram-card__counter-card-block !w-full h-full">
              <p
                [afTranslate]="'common.total'"
                class="common-diagram-card__counter-card-title-md">
                _Total
              </p>
              <div class="common-diagram-card__counter-card-count-block">
                <p class="common-diagram-card__counter-card-count-text">
                  {{importModal.allFields.length}}
                </p>
              </div>
              <div class="common-diagram-card__counter-card-bootm-block">
                <i class="lf-icon-build common-icon__xl common-import-modal__analized-total-icon">
                </i>
              </div>
            </li>
            <li class="common-diagram-card__counter-card-block !w-full h-full">
              <p
                [afTranslate]="'users-admin.import.validate-contacts-card'"
                class="common-diagram-card__counter-card-title-md">
                _Validadas
              </p>
              <div class="common-diagram-card__counter-card-count-block">
                <p class="common-diagram-card__counter-card-count-text">
                  {{importModal.validateFields.length}}
                </p>
              </div>
              <div class="common-diagram-card__counter-card-bootm-block">
                <i class="lf-icon-check-round common-icon__xl common-special-icon__solid">
                </i>
              </div>
            </li>
            <li class="common-diagram-card__counter-card-block !w-full h-full">
              <p
                [afTranslate]="'users-admin.import.incomplete'"
                class="common-diagram-card__counter-card-title-md">
                _Incompletas
              </p>
              <div class="common-diagram-card__counter-card-count-block">
                <p class="common-diagram-card__counter-card-count-text">
                  {{incompleteFields.length}}
                </p>
              </div>
              <div class="common-diagram-card__counter-card-bootm-block">
                <i class="lf-icon-warning common-icon__xl common-special-icon__solid">
                </i>
                @if (incompleteFields.length) {
                  <button
                    (click)="changeView('warning-fields')"
                    class="common-button__link">
                    <span
                      [afTranslate]="'common.required-fields'"
                      class="common-button__link-text">
                      _Campos obligatorios
                    </span>
                  </button>
                }
              </div>
            </li>
            <li class="common-diagram-card__counter-card-block !w-full h-full">
              <p
                [afTranslate]="'common.error'"
                class="common-diagram-card__counter-card-title-md">
                _Error
              </p>
              <div class="common-diagram-card__counter-card-count-block">
                <p class="common-diagram-card__counter-card-count-text">
                  {{errorFields.length}}
                </p>
              </div>
              <div class="common-diagram-card__counter-card-bootm-block">
                <i class="lf-icon-close-round common-icon__xl common-special-icon__solid"></i>
                @if (errorFields.length) {
                  <button
                    (click)="changeView('error-contacts')"
                    class="common-button__link">
                    <span
                      [afTranslate]="'users-admin.import.errors-form'"
                      class="common-button__link-text">
                      _Informe de errores
                    </span>
                  </button>
                }
              </div>
            </li>
          </ul>
        </div>
      }
  </div>
  <div class="common-modal__footer">
    @if (importModal.view !== 'error-contacts' && importModal.view !== 'error-concepts' && importModal.view !== 'warning-fields' && importModal.view !== 'view-error' && importModal.view !== 'error-clients') {
      <button
        (click)="handleDismiss()"
        [ngClass]="{
          'common-button__text-noborder': importModal.view === 'analized-clients' || importModal.view === 'analized-concepts',
          'common-button__text-border': importModal.view !== 'analized-clients' && importModal.view !== 'analized-concepts'
        }">
        <span
          [afTranslate]="'common.cancel'"
          class="common-button__text-title">
          _Cancelar
        </span>
      </button>
      @if (importModal.view === 'analized-contacts' || importModal.view === 'analized-concepts' || importModal.view === 'analized-clients') {
        <button
          (click)="previous()"
          class="common-button__text-border">
          <span
            [afTranslate]="'common.previous'"
            class="common-button__text-title">
            _Anterior
          </span>
        </button>
        <button
          [disabled]="(!importModal.validateFields.length && !incompleteFields.length) || (errorFields.length && importModal.view !== 'analized-concepts')"
          (click)="close()"
          class="common-button__text">
          <span
            [afTranslate]="'evaluation-import.buttons.import'"
            class="common-button__text-title">
            _Importar
          </span>
        </button>
      }
      @if (importModal.view === 'select-file') {
        <button
          (click)="analizeClick()"
          class="common-button__text">
          <span
            [afTranslate]="'users-admin.import.analize-file'"
            class="common-button__text-title">
            _Analizar archivo
          </span>
        </button>
      }
    }
    @if (importModal.view === 'error-contacts' || importModal.view === 'error-concepts' || importModal.view === 'warning-fields' || importModal.view === 'error-clients') {
      <button
        (click)="importModal.view = 'analized-' + type"
        class="common-button__text">
        <span
          [afTranslate]="'common.return'"
          class="common-button__text-title">
          _Volver
        </span>
      </button>
    }
  </div>
</div>
